import React, {useEffect, useState} from 'react'
import { KeyboardArrowUp } from '@mui/icons-material';
import MainContent from '../components/firstFiftyOnboarding/MainContent';
import '../components/firstFifty/firstFifty.css'
import Header from '../components/Header/Header';

function FirstFiftyOnboarding() {
    const [showScroll, setShowScroll] = useState(false);
      
    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const rootElement = document.getElementById("root");
            if (rootElement) {
                if (scrollY >= 70) {
                rootElement.classList.add("sticky");
                } else {
                rootElement.classList.remove("sticky");
                }
            }
        
            if (scrollY > 100) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };
    
        window.addEventListener("scroll", handleScroll);
    
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    
        const scrollToTop = () => {
            const duration = 2000; // in milliseconds (1000ms = 1s)
            const start = window.scrollY;
            const startTime = performance.now();
        
            const animateScroll = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1); // 0 to 1
        
            // easeInOutQuad easing function
            const ease = progress < 0.5
                ? 2 * progress * progress
                : -1 + (4 - 2 * progress) * progress;
        
            window.scrollTo(0, start * (1 - ease));
        
            if (elapsed < duration) {
                requestAnimationFrame(animateScroll);
            }
        };
    
        requestAnimationFrame(animateScroll);
    };

    return (
        <div className="landing-page">

            <div id="wrapper" >

                {/* <header id="header">
                    <div className="row ">
                        <div className="header-section ">
                            <div className="container">
                                <div className="header-wrap ">
                                    <div className="logo-section ">
                                        <div className="image">
                                            <a href="landing.html">
                                                <img src="/images/firstFifty-images/landing-header.png" alt="header logo" />
                                            </a>
                                                
                                        </div>
                                    </div>
                                    <div className="login-form">
                                        <div className="login-form-wrap">
                                            <form action="action_page.php" method="post">
                                                <div className="field username">
                                                    <input type="text" placeholder="Username" name="uname" required="" />
                                                </div>

                                                <div className="field password">
                                                    <input type="password" placeholder="Password" name="psw" required="" />
                                                </div>

                                                <div className="submit-btn">
                                                    <button type="submit">Login</button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                    <div className="call-section">
                                        <div className="phone-no">
                                            <a href="tel:(800) 820-6020">(800) 820-6020</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header> */}

                <Header />

                <main>
                    <MainContent />
                </main>

                <footer id="footer" className="landing-footer">
                    <div className="row">
                        <div className="container">
                            <div className="copyright-container-wrap">
                                <p> © 2025 <a href="Landing.html"> Snapshot Videos </a> - All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                </footer>

            </div>
            <a onClick={scrollToTop} id="myBtn" style={{ display: showScroll ? "flex" : "none", justifyContent: 'center', alignItems: 'center' }}><KeyboardArrowUp fontSize="large" /></a>

        </div>
    )
}

export default FirstFiftyOnboarding